import { Controller } from "@hotwired/stimulus"

// Simple dropdown controller for toggle menus
export default class extends Controller {
  static targets = ["menu"]

  connect() {
    this.handleClickOutside = this.handleClickOutside.bind(this)
    this.handleKeydown = this.handleKeydown.bind(this)
  }

  disconnect() {
    this.removeEventListeners()
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    if (this.menuTarget.classList.contains("hidden")) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    this.menuTarget.classList.remove("hidden")
    
    requestAnimationFrame(() => {
      document.addEventListener("click", this.handleClickOutside, true)
      document.addEventListener("keydown", this.handleKeydown)
    })
  }

  close() {
    this.menuTarget.classList.add("hidden")
    this.removeEventListeners()
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      event.preventDefault()
      this.close()
    }
  }

  removeEventListeners() {
    document.removeEventListener("click", this.handleClickOutside, true)
    document.removeEventListener("keydown", this.handleKeydown)
  }
}
